import React from "react";
import { FunctionComponent } from "react";
import { White } from "@traceair/tds";
import NavItem from "./NavItem";
import NavLabel from "./NavLabel";


interface IBackButtonProps {
  onClick: () => void;
  label: string;
}
const BackButton: FunctionComponent<IBackButtonProps> = ({
  onClick,
  label,
}: IBackButtonProps) => (
  <NavItem
    onClick={onClick}
    icon={<ArrowBack />}
    content={<NavLabel label={label} />}
  />
);

const ArrowBack = () => (
  <svg width={"24px"} height={"24px"} viewBox="0 0 24 24">
    <g
      id="ic/arrow-back-w"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
      <polygon
        id="Shape"
        fill={White}
        fillRule="nonzero"
        points="16.42 5.41 15 4 7 12 15 20 16.41 18.59 9.83 12"
      />
    </g>
  </svg>
);

export default BackButton;
